<div class="process-selection">
  <app-centered-scrollable-content>

    <div class="grid">
      @for (entry of processSelectionConfiguration?.selectOptions; track entry) {
        <div class="column">
          <div class="center">
            <app-tapable-terminal-card>
              <app-icon-tile [iconScale]="2" [title]="getTitle(entry)" [iconCSS]="entry.titleIconCss" (click)="select(entry)">
              </app-icon-tile>
            </app-tapable-terminal-card>
          </div>
          @if (entry.descriptionDictionaryKey != null) {
            <p class="description">
              <sc-dictionary-label [dictionaryKey]="entry.descriptionDictionaryKey"></sc-dictionary-label>
            </p>
          }
        </div>
      }
    </div>
  </app-centered-scrollable-content>
</div>
